import { Component, ElementRef, Inject, TemplateRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationRepository } from '../../../core/repositories/authentication.repository';
import { ToastMessageService } from '../../../core/services/toast-message.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-dialog-new',
  templateUrl: './dialog-new.component.html',
  styleUrl: './dialog-new.component.scss',
})
export class DialogNewComponent {
  protected ngUnsubscribeHttp: Subject<void> = new Subject<void>();
  changePasswordForm!: FormGroup;
  isSubmit = false;

  errOldPassword: string = '';
  errNewPassword: string = '';
  errConfirmPassword: string = '';
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      content?: TemplateRef<any>;
      closeFn?: () => void;
    },
    private dialogRef: MatDialogRef<DialogNewComponent>,
    private fb: FormBuilder,
    private authRepository: AuthenticationRepository,
    private toastService: ToastMessageService,
    public el: ElementRef
  ) {
    this.initForm();
  }

  passwordFields = [
    {
      placeholder: 'LOGIN.PLACEHOLDER.MKHIENTAI',
      visible: false,
      controlName: 'passwordOld',
    },
    {
      placeholder: 'LOGIN.PLACEHOLDER.MKMOI',
      visible: false,
      controlName: 'passwordNew',
    },
    {
      placeholder: 'LOGIN.PLACEHOLDER.XACNHANMK',
      visible: false,
      controlName: 'confirmPassword',
    },
  ];

  private initForm() {
    this.changePasswordForm = this.fb.group(
      {
        userId: [Number(localStorage.getItem('userId'))],
        passwordOld: ['', Validators.required],
        passwordNew: ['', [Validators.required, Validators.minLength(6)]],
        confirmPassword: ['', Validators.required],
      },
      { validator: this.passwordMatchValidator }
    );
  }

  get f(): any {
    return this.changePasswordForm.controls;
  }

  // ... existing code ...
  private passwordMatchValidator(g: FormGroup) {
    const passwordNew = g.get('passwordNew')?.value;
    const confirmPassword = g.get('confirmPassword')?.value;
    return passwordNew === confirmPassword ? null : { mismatch: true };
  }
  // ... existing code ...

  togglePasswordVisibility(index: number) {
    this.passwordFields[index].visible = !this.passwordFields[index].visible;
  }

  // ... existing code ...
  focusOnInvalid(inputForm: FormGroup) {
    for (const key of Object.keys(inputForm.controls)) {
      if (inputForm.controls[key].invalid) {
        const invalidControl = this.el.nativeElement.querySelector(
          '[formcontrolname="' + key + '"]'
        );
        if (invalidControl) {
          invalidControl.focus();
        }
        break;
      }
    }
  }
  checkValidateForm() {
    this.isSubmit = true;
    let isValid = true;

    // Reset error messages
    this.errOldPassword = '';
    this.errNewPassword = '';
    this.errConfirmPassword = '';

    // Validate passwordOld
    if (!this.f.passwordOld.value || !this.f.passwordOld.value.trim()) {
      this.errOldPassword = 'Vui lòng nhập mật khẩu hiện tại!';
      this.changePasswordForm.get('passwordOld')?.setErrors({ required: true });
      isValid = false;
    }

    // Validate passwordNew
    if (!this.f.passwordNew.value || !this.f.passwordNew.value.trim()) {
      this.errNewPassword = 'Vui lòng nhập mật khẩu mới!';
      this.changePasswordForm.get('passwordNew')?.setErrors({ required: true });
      isValid = false;
    } else if (this.f.passwordNew.value.trim().length < 6) {
      this.errNewPassword = 'Mật khẩu phải có ít nhất 6 ký tự!';
      this.changePasswordForm
        .get('passwordNew')
        ?.setErrors({ minlength: true });
      isValid = false;
    } else if (
      this.f.passwordOld.value &&
      this.f.passwordNew.value.trim() === this.f.passwordOld.value.trim()
    ) {
      this.errNewPassword =
        'Mật khẩu mới không được trùng với mật khẩu hiện tại!';
      this.changePasswordForm
        .get('passwordNew')
        ?.setErrors({ sameAsOld: true });
      isValid = false;
    }

    // Validate confirmPassword
    if (!this.f.confirmPassword.value || !this.f.confirmPassword.value.trim()) {
      this.errConfirmPassword = 'Vui lòng nhập lại mật khẩu!';
      this.changePasswordForm
        .get('confirmPassword')
        ?.setErrors({ required: true });
      isValid = false;
    } else if (
      this.f.passwordNew.value &&
      this.f.passwordNew.value.trim() !== this.f.confirmPassword.value.trim()
    ) {
      this.errConfirmPassword = 'Mật khẩu không khớp!';
      this.changePasswordForm
        .get('confirmPassword')
        ?.setErrors({ mismatch: true });
      isValid = false;
    }

    if (!isValid) {
      this.changePasswordForm.markAllAsTouched();
      this.focusOnInvalid(this.changePasswordForm);
    }

    return isValid;
  }
  // async onSubmit() {
  //   if (!this.checkValidateForm()) {
  //     return;
  //   }
  //   if (this.changePasswordForm.valid) {
  //     try {
  //       const result = await this.authRepository.changePassword(Number(localStorage.getItem("userId")),this.changePasswordForm.value);
  //       console.log(result)
  //       if (result) {
  //         this.toastService.show('LOGIN.MESSAGE.DOIMKTHANHCONG', 'success');
  //         this.dialogRef.close(true);
  //       }
  //     } catch (error) {
  //       this.toastService.show('LOGIN.MESSAGE.DOIMKTHATBAI', 'error');
  //     }
  //   } else {
  //     this.toastService.show('LOGIN.MESSAGE.VUI longNHAPDAYDU', 'error');
  //   }
  // }

  onSubmit() {
    if (!this.checkValidateForm()) {
      return;
    }
    let req = this.changePasswordForm.getRawValue();
    this.authRepository
      .changePassword(Number(localStorage.getItem('userId')), req)
      .pipe(takeUntil(this.ngUnsubscribeHttp))
      .subscribe((res) => {
        if (res.meta?.error_code === 200) {
          this.toastService.show('Cập nhật tài khoản thành công!', 'success');
          this.dialogRef.close(true);
          // this.dialogRef.close();
          // if (typeof this.data.closeFn === 'function') {
          // }
        } else {
          this.toastService.show(
            res.meta?.error_message ?? 'Thất bại!',
            'error'
          );
          return;
        }
      });
  }
  // ... existing code ...

  checkOldPassword() {
    this.errOldPassword = '';
    if (!this.f.passwordOld.value || !this.f.passwordOld.value.trim()) {
      this.errOldPassword = 'Vui lòng nhập mật khẩu hiện tại!';
      this.changePasswordForm.get('passwordOld')?.setErrors({ required: true });
    } else {
      this.changePasswordForm.get('passwordOld')?.setErrors(null);
      // Re-check new password if old password changes
      if (this.f.passwordNew.value) {
        this.checkNewPassword();
      }
    }
  }

  checkNewPassword() {
    this.errNewPassword = '';
    if (!this.f.passwordNew.value || !this.f.passwordNew.value.trim()) {
      this.errNewPassword = 'Vui lòng nhập mật khẩu mới!';
      this.changePasswordForm.get('passwordNew')?.setErrors({ required: true });
    } else if (this.f.passwordNew.value.trim().length < 6) {
      this.errNewPassword = 'Mật khẩu phải có ít nhất 6 ký tự!';
      this.changePasswordForm
        .get('passwordNew')
        ?.setErrors({ minlength: true });
    } else if (
      this.f.passwordOld.value &&
      this.f.passwordNew.value.trim() === this.f.passwordOld.value.trim()
    ) {
      this.errNewPassword =
        'Mật khẩu mới không được trùng với mật khẩu hiện tại!';
      this.changePasswordForm
        .get('passwordNew')
        ?.setErrors({ sameAsOld: true });
    } else {
      this.changePasswordForm.get('passwordNew')?.setErrors(null);
    }
    // Re-check confirm password when new password changes
    if (this.f.confirmPassword.value) {
      this.checkComparePassword();
    }
  }

  checkComparePassword() {
    this.errConfirmPassword = '';
    if (!this.f.confirmPassword.value || !this.f.confirmPassword.value.trim()) {
      this.errConfirmPassword = 'Vui lòng nhập lại mật khẩu!';
      this.changePasswordForm
        .get('confirmPassword')
        ?.setErrors({ required: true });
    } else if (
      this.f.passwordNew.value &&
      this.f.confirmPassword.value.trim() !== this.f.passwordNew.value.trim()
    ) {
      this.errConfirmPassword = 'Mật khẩu không khớp!';
      this.changePasswordForm
        .get('confirmPassword')
        ?.setErrors({ mismatch: true });
    } else {
      this.changePasswordForm.get('confirmPassword')?.setErrors(null);
    }
  }
}
